<template>
  <div class="app-protection-document">

    <input-title :required="options.required" :description="options.description"/>

    <div class="input-groups">

      <div
        v-for="(_, i) in valueLocal"
        :key="`input-group-${i}`"
        class="input-group">
        <div class="input-subtitle">Реестр</div>
        <el-select
          v-if="options.Registries"
          v-model="valueLocal[i].RegistryId"
          :key="`app-link-opt-${i}`"
          v-bind="widgetOptions"
          :clearable="true">
          <el-option
            v-for="(value, i) in options.Registries"
            class="select-option"
            :key="`app-protection-opt-option-${i}`"
            :label="`${value.RegistryName}`"
            :value="value.RegistryId"/>
        </el-select>
        <template v-if="valueLocal[i].RegistryId">
          <div class="input-subtitle">{{ getDocumentName(i) }}</div>
          <el-input
            :class="{ 'child-has-error': error[i].number }"
            @focus="clearError('number', i)"
            v-model="valueLocal[i].Number"/>
          <div v-if="error[i].number" class="ait_message ait_message--error">
            {{ error[i].number }}
          </div>
          <div class="input-subtitle">Описание</div>
          <el-input
            :class="{ 'child-has-error': error[i].description }"
            @focus="clearError('description', i)"
            v-model="valueLocal[i].Description"/>
          <div v-if="valueLocal[i].Number && valueLocal[i].RegistryId !== 'other'"
            class="prt-document-info">
            <button
              @click="getPrtDocInfo(valueLocal[i].RegistryId, valueLocal[i].Number)"
              class="btn-document-info">
              Информация о документе
            </button>
          </div>
          <div v-if="error[i].description" class="ait_message ait_message--error">
            {{ error[i].description }}
          </div>
        </template>
        <div v-if="error[i].required" class="ait_message ait_message--error">
          {{ error[i].required }}
        </div>
      </div>

    </div>

    <add-rem-btns/>

    <el-dialog
      title="Охранный документ"
      class="prt-document-full"
      :visible.sync="docInfoVisible">
      <div v-if="docInfo.ObjectTitle">
        <span class="prt-document-title">
          Название объекта:</span> {{ docInfo.ObjectTitle }}
      </div>
      <div v-if="docInfo.DocumentNumber">
        <span class="prt-document-title">
          Номер регистрации (свидетельства):
        </span>
        {{ docInfo.DocumentNumber }}
      </div>
      <div v-if="docInfo.DocumentRegistrationDate">
        <span class="prt-document-title">
          Дата регистрации:
        </span>
        {{ docInfo.DocumentRegistrationDate }}
      </div>
      <div v-if="docInfo.ObjectAuthors">
        <span class="prt-document-title">
          Автор{{ docInfo.ObjectAuthors.length > 1 ? 'ы' : '' }}:
        </span>
        {{ docInfo.ObjectAuthors.join(', ') }}
      </div>
      <div v-if="docInfo.ObjectCopyrightHolders">
        <span class="prt-document-title">
          Правообладател{{
            docInfo.ObjectCopyrightHolders.length > 1 ? 'и' : 'ь'
          }}:
        </span>
        {{ docInfo.ObjectCopyrightHolders.join(', ') }}
      </div>
      <div v-if="docInfo.DocumentURL">
        <span class="prt-document-title">
          Ссылка на документ:
        </span>
        <a
          :href="`${docInfo.DocumentURL}`"
          target="_blank">
          {{ cutText(docInfo.DocumentURL, 50) }}
        </a>
      </div>
      <div v-if="docInfo.ObjectAnnotation">
        <span class="prt-document-title">
          Аннотация:
        </span>
        {{ docInfo.ObjectAnnotation }}
      </div>

      <span slot="footer" class="dialog-footer">
        <button
          class="dialog-primary-btn"
          @click="docInfoVisible = false">
          Закрыть окно
        </button>
      </span>

    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import Common from './mixins/Common';

export default {

  mixins: [Common],

  data() {
    return {
      valueBase: {
        relation: '',
        format: '',
        link: '',
        title: '',
      },
      errorBase: { required: '', number: '', description: '' },
      docInfo: {},
      docInfoVisible: false,      
    };
  },

  created() {
    this.error.push(this.errorBase);
    this.widgetOptions.placeholder = 'Выберите значение...';
    // Add error messages
    this.validateMessages = Object.assign(
      this.validateMessages, {
        number: 'Введите номера свидетельства',
        description: 'Заполните описание документа',
      },
    );
    if (this.options.Registries[0] && this.options.Registries[0].RegistryId !== 'other') {
      this.options.Registries.unshift({
        RegistryName: 'Другой реестр',
        RegistryId: 'other',
        DocumentName: 'Номер свидетельства',
      });
    }
  },

  methods: {
    getPrtDocInfo(registryId, document) {
      const documentNumber = encodeURIComponent(document);
      axios.get(`registries/${registryId}/documents?documentNumber=${documentNumber}`).then((response) => {
        this.docInfo = response.data;
        this.docInfoVisible = true;
      }).catch((err) => {
        const r = err.response;
        if (r.status === 404) {
          this.$message('Охранный документ не найден');
        } else if (r.data) {
          this.$message(r.data);
        } else {
          this.$message(r.statusText);
        }
      });
    },

    cutText(text, size) {
      if (text.length > size) {
        return `${text.substr(0, size)}...`;
      }
      return text;
    },

    getDocumentName(index) {
      let documentName = '';
      for (let i = 0; i < this.options.Registries.length; i += 1) {
        if (this.options.Registries[i].RegistryId === this.valueLocal[index].RegistryId
          && this.options.Registries[i].DocumentName) {
          documentName = this.options.Registries[i].DocumentName;
          break;
        }
      }
      return documentName;
    },

    setValue(value) {
      this.valueLocal = [];
      value.forEach((v, i) => {
        this.error[i] = this.errorBase;
        this.valueLocal.push({
          RegistryId: v.RegistryId ? v.RegistryId : 'other',
          Number: v.Number,
          Description: v.Description,
        });
      });
      this.$forceUpdate();
    },

    getValue() {
      const vl = this.valueLocal;
      const r = [];
      vl.forEach((v) => {
        if (v.Number) {
          r.push({
            RegistryId: v.RegistryId !== 'other' ? v.RegistryId : '',
            Number: v.Number,
            Description: v.Description,
          });
        }
      });
      if (this.options && this.options.multiple) {
        return r;
      }
      return r.length ? r[0] : null;
    },

    getError() {
      this.valueLocal.forEach((value, i) => {
        this.error[i] = { required: '', number: '' };
        if (this.options.required && value.RegistryId === '') {
          this.error[i].required = this.validateMessages.required;
        }
        if (value.RegistryId && !value.Number) {
          this.error[i].number = this.validateMessages.number;
        }
        if (value.RegistryId === 'other' && !value.Description) {
          this.error[i].description = this.validateMessages.description;
        }
      });
      this.updateValue();
      return this.error;
    },

    clearError(elName, i) {
      if (this.error[i][elName]) {
        this.error[i].required = '';
        this.error[i][elName] = '';
        this.$forceUpdate();
      }
    },

  },
};
</script>

<style lang="scss" scoped>
.app-protection-document {
  .input-group {
    border-bottom: 1px dotted rgba(255, 255, 255, .3);
    padding-bottom: 32px;
    &:last-of-type {
      border-bottom: none!important;
      padding-bottom: 20px;
    }
  }
  .el-switch,
  .input-subtitle {
    margin-top: 20px;
  }
  .format-example {
    margin-top: 5px;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.5);
  }
  .prt-document-info {
    padding: 20px 0 0;
    text-align: center;
    .btn-document-info {
      padding: 5px;
      cursor: pointer;
      background: transparent;
      color: #fff;
      border: 1px solid #d85486;
      margin-bottom: 10px;
      border-radius: 20px;
      width: 210px;
      transition: all 0.3s;
      text-align: center;
      &:hover {
        background: #d85486;
      }
    }
  }
  .prt-document-full {
    div {
      padding-top:5px;
      color: #333;
      .prt-document-title {
        color: #999;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/inputs/widgets/AppProtectionDocument.vue